// extracted by mini-css-extract-plugin
export default {"form":"sign-up_form__wdgxH","submit":"sign-up_submit__hlsTQ"};